(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('RelatorioAvalOrgaoService', RelatorioAvalOrgaoService);

  function RelatorioAvalOrgaoService($http, ngsalConfig) {

    var service = {
      exportarExcel: exportarExcel
    };

    return service;

    function exportarExcel(orgaos) {
      var promise = $http.post(`/mgp-corregedoria/api/${ngsalConfig.apiVersion}/corregedoria/relatorioAvalOrgao`, orgaos, {
        responseType: 'blob',
        headers:{
          Accept:'application/vnd.ms-excel'
        }
      }).then(function (response) {
        return {data: response.data, status: response.status};
      });

      return promise;

    }
  }

})();
